function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.726.413L.113 5.04a.388.388 0 00.549.547L5 1.236l4.338 4.35a.388.388 0 10.549-.547L5.274.413a.387.387 0 00-.548 0z",
  fill: "#F2C94C"
});

function SvgIconSortDirection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    fill: "none"
  }, props), _ref);
}

export default SvgIconSortDirection;